import LoadingScreen from "@components/LoadingScreen";
import {
  getAllBmas,
  getAllIcps,
  getBmaProfileById,
  VpsProfile,
} from "@redux/slices/strategicPlanning";
import React, { useEffect, useState } from "react";

const ReadmeBma = () => {
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState("");
  const [data, setData] = useState<VpsProfile>();

  useEffect(() => {
    setLoading(true);
    setId(window.location.pathname.split("/")[2]);
    getData();
  }, []);

  const getData = async () => {
    const data1 = await getBmaProfileById(
      Number(window.location.pathname.split("/")[2])
    );
    setData(data1);
    setLoading(false);
  };

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div className="px-80 pb-20">
          <h4 className="text-xl font-medium mb-10 mt-5 text-center">
            Business Model and Market Analysis (BMA)
          </h4>
          <h6 className="text-lg">
            1. What is the current pricing structure of your product/service,
            and how do you justify this price?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question1}</p>
          <h6 className="text-lg">
            2. What different pricing strategies have you tested, and which were
            the most successful?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question2}</p>{" "}
          <h6 className="text-lg">
            3. How do you measure the Return on Investment (ROI) for your
            customers?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question3}</p>{" "}
          <h6 className="text-lg">
            4. What additional services or products do you offer to increase
            value for your customers?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question4}</p>{" "}
          <h6 className="text-lg">
            5. What market trends and innovations do you observe in your
            industry that could affect your business model?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question5}</p>{" "}
          <h6 className="text-lg">
            6. How do your competitors respond to these trends and innovations?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question6}</p>{" "}
          <h6 className="text-lg">
            7. What new market opportunities do you see in the next 2-5 years?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question7}</p>{" "}
          <h6 className="text-lg">
            8. How do you plan to respond to these market opportunities?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question8}</p>{" "}
          <h6 className="text-lg">
            9. What technologies or developments could disrupt your business
            model in the future?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question9}</p>{" "}
          <h6 className="text-lg">
            10. How do you adapt your business model to remain competitive and
            respond to market changes?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question10}</p>
        </div>
      )}
    </div>
  );
};

export default ReadmeBma;
